import dayjs from 'dayjs';
export function getFormattedDateTime(date, format = 'DD/MM/YYYY HH:mm:ss') {
    return dayjs(date).format(format);
}
//# sourceMappingURL=getFormattedDateTime.js.map